import { useGetCurrentUserQuery } from '@/features/users';
import { useMemo } from 'react';

export function useBelongsToMyCompany(company?: string | null) {
  const { data: user, isLoading } = useGetCurrentUserQuery();

  const result = useMemo(() => {
    if (isLoading || !user) {
      return undefined;
    }

    if (!company) {
      return false;
    }

    return user?.company?.id === company;
  }, [user, company, isLoading]);

  return result;
}
